import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
	name: 'istResumeDate',
	standalone: true
})
export class IstDatePipe implements PipeTransform {

	transform(value: string): string {
		if (!value) return '';
		const utcDate = value.endsWith('Z') ? value : value + 'Z';
		return formatDate(utcDate, 'MMM d, y, hh:mm a', 'en-IN', 'Asia/Kolkata');
	}

}